import { InputBaseStyle, InputSizes, InputVariants } from './input';

const select = {
  baseStyle: InputBaseStyle,
  variants: InputVariants,
  sizes: InputSizes,
  defaultProps: {
    colorScheme: false,
    variant: 'outline'
  }
};

export default select;